import { SVGProps } from 'react'

export const InformationSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M426.949775 615.815H288.484775a34.605 34.605 0 1 0 0 69.21H426.949775a34.605 34.605 0 1 0 0-69.21z m173.07-173.07H288.484775a34.605 34.605 0 0 0 0 69.21h311.535a34.605 34.605 0 0 0 0-69.21z m0-173.07H288.484775a34.605 34.605 0 0 0 0 69.21h311.535a34.605 34.605 0 0 0 0-69.21z' />
      <path d='M802.699775 235.07v-34.605A138.06 138.06 0 0 0 665.899775 62H221.299775A138.06 138.06 0 0 0 84.499775 200.465v623.07A138.06 138.06 0 0 0 221.299775 962h581.4A138.06 138.06 0 0 0 939.499775 823.535v-450a138.06 138.06 0 0 0-136.8-138.465z m68.4 588.465a69.03 69.03 0 0 1-68.4 69.21H221.299775a69.03 69.03 0 0 1-68.4-69.21V200.465a69.03 69.03 0 0 1 68.4-69.21h444.6a69.03 69.03 0 0 1 68.4 69.21v519.21a34.2 34.2 0 1 0 68.4 0V304.28a69.03 69.03 0 0 1 68.4 69.21z' />
    </svg>
  )
}
